import { useListTranslation } from '@cbgms/components/list/use-list-translation'
import { Box, Typography } from '@mui/material'

interface DataGridHeaderProps {
  field: string
}

export function DataGridHeader({ field }: DataGridHeaderProps) {
  const { tl } = useListTranslation()
  const [, columnName] = tl(field)
  return (
    <Box>
      <Typography variant='body2' sx={{ fontWeight: theme => theme.typography.fontWeightMedium }}>
        {columnName}
      </Typography>
    </Box>
  )
}
